$(function () {

  var homeBrandSelect = $('.home-brand-select');

  $.each(homeBrandSelect, function (index, select) {
    var brandSelect = $(select);
    var selectForm = brandSelect.closest('.homepage_search');
    var modelSelect = selectForm.find('.home-model-select');

    var preselectedBrandId = brandSelect.attr('data-selected');
    if (preselectedBrandId) {
      updateModelSelect(brandSelect.data('car-type'), preselectedBrandId, modelSelect);
    }

    brandSelect.on('change', function () {
      var brandId = $(this).val();
      var carType = brandSelect.data('car-type');

      updateModelSelect(carType, brandId, modelSelect);
    });
  });

  function updateModelSelect(carType, brandId, modelSelect) {
    var url = '/api/v1/listing/available-search-data/makes_with_id/' + brandId + '/' + carType;

    if (brandId) {
      updateDynamicSelect(url, modelSelect);
    } else {
      cleanAndDisableSelect(modelSelect);
    }
  }

  function updateDynamicSelect(url, selectToUpdate) {
    selectToUpdate.prop('disabled', true);
    selectToUpdate.trigger('chosen:updated');
    $.ajax({
      method: 'GET',
      url: location.origin + url
    }).done(function (response) {

      var options = '<option value="">' + I18n.t('js.all') + '</option>';
      $.each(response, function (index, option) {
        options += '<option value=' + option.id + '>' + option.name + '</option>'
      });

      var selected = selectToUpdate.attr('data-selected');
      if (selected) {
        selectToUpdate.val(selected);
        selectToUpdate.attr('data-selected', null);
      }

      selectToUpdate.html(options);
      selectToUpdate.val(selected);
      selectToUpdate.prop('disabled', false);
      selectToUpdate.trigger('chosen:updated');
    });
  }

  function cleanAndDisableSelect(selectToUpdate) {
    var options = '<option value="">Select make first</option>';
    selectToUpdate.html(options);
    selectToUpdate.prop('disabled', true);
    selectToUpdate.trigger('chosen:updated');
  }

  $('#sort_by').on('change', function () {
    $('#ad-hidden-sort-by').val($(this).val());
    $('#filter_form').submit();
  });

});


// WEBPACK FOOTER //
// ./app/webpacker/src/js/ajax_selects_home.js